<template>
  <modal-vue :visible.sync="isVisible" :content_loaded="!loading" :title="t('components.rfc_alerts.modal.title')">
    <template v-slot:header>{{ t("components.rfc_alerts.modal.title") }}</template>
    <template v-slot:body>
      <div class="no-result" >{{ t("components.rfc_alerts.modal.subtitle", { rfc_code: rfcCode }) }}</div>
      <forms-generic-input-vue
          input_type="filled"
          input_name="nombre"
          input_field="components.rfc_alerts.modal.placeholder"
          form_name='alert_form'
          :bus="input_bus"
          :auto_validates="false"
          @input_changed="setRfcName"
          @enter:pressed="handleSave"
          :default_value="''"
          :button_classes="['form-control', 'form-control', 'mt-3']"
        />
        <forms-messages-list-vue
          id="errors"
          :messages="errors"
          :single_message="true"
        />
    </template>
    <template v-slot:footer>
      <div v-if="!loading">
        <button id="save" @click="handleSave" class="btn btn-primary">
          {{ t("guardar") }}
        </button>
        <button id="cancel" @click="hide" class="btn btn-secondary">
          {{ t("cancel") }}
        </button>
      </div>
      <div v-else/>
    </template>
  </modal-vue>
</template>
<script>

import Vue from "vue"
import { mapState, mapActions } from 'vuex'
import mixins from "common/mixins"

export default {
  name: "user-subscription-modal-rfc-alert-vue",
  mixins: [mixins.translate],
  props: {
    rfcCode: { type: String, default: "" },
  },
  components: {
    "modal-vue": () =>
      import(/* webpackChunkName: "[request]" */ "components/Modal"),
    "forms-generic-input-vue": () => import(/* webpackChunkName: "[request]" */ "components/forms/GenericInput"),
    "forms-messages-list-vue": () => import(/* webpackChunkName: "[request]" */ "components/forms/MessagesList")
  },
  data() {
    return {
      input_bus: new Vue(),
      isVisible: false,
      alertName: '',
      error: false
    }
  },
  methods: {
    show() { this.isVisible = true },
    hide() {
      this.isVisible = false
      this.alertName = ''
    },
    async handleSave(){
      this.input_bus.$emit("validate_input")
      if (this.alertName == "") return

      await this.create_alert({
          rfc: this.rfcCode,
          name: this.alertName
      })

      if(Object.keys(this.errors).length == 0){
        this.hide()
        this.$store.commit('rfc_search/add_existing_rfc_alert', true)
      }else{
        this.error = true
      }
    },
    setRfcName(input_value) {
      this.alertName = input_value
    },
    ...mapActions("rfc_alerts", ["create_alert"])
  },
  computed: {
    ...mapState("rfc_alerts", ["loading", "errors"])
  }
};
</script>
